import { useSelector } from 'react-redux'
import ImagesGalleryCN from '../contentPages/ImagesGalleryCN'

const ImagesLibraryCN = () => {
	const userLogin = useSelector((state: any) => state.userLogin)
	const { userInfo: user } = userLogin
	const userId = user._id

	return <ImagesGalleryCN />
}

export default ImagesLibraryCN
